import { makeAutoObservable } from "mobx";

export class MessageMobileHandleStore {
  userIsHoldingMouseDown = false;
  timeoutId: number | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setUserIsHoldingMouseDown(isHolding: boolean) {
    this.userIsHoldingMouseDown = isHolding;
  }

  handleMouseDown = () => {
    this.timeoutId = setTimeout(() => {
      this.setUserIsHoldingMouseDown(true);
    }, 1000) as unknown as number;
  };

  clearHoldingTimeout() {
    if (!this.timeoutId) return;
    clearTimeout(this.timeoutId);
    this.timeoutId = null;
  }

  handleMouseUp = (e: React.TouchEvent<HTMLDivElement>) => {
    if (this.userIsHoldingMouseDown) {
      e.preventDefault();
      e.stopPropagation();
    }
    this.clearHoldingTimeout();
    this.setUserIsHoldingMouseDown(false);
  };
}
